import React from "react";
import { useTranslation } from "react-i18next";

export default function AboutThree({ profile }) {
  const { t } = useTranslation();

  return (
    <div className="bostami-page-content-wrap living-about-panel">
      <div className="section-wrapper living-about-section">
        <div className="bostami-page-title-wrap">
          <div className="living-section-heading">
            <h2 className="page-title">{t("app.sobreMi")}</h2>
            <span aria-hidden="true"></span>
          </div>
          <p>{profile?.perfil.descripcion}</p>
          <p>{profile?.perfil.experiencia}</p>
        </div>
      </div>
    </div>
  );
}
